import { get, post } from '../utils/api';

export default class ForecastRentsUtilityAllowanceFormService {
  async upsertForecastRentsUtilityAllowanceForm(data) {
    return await post(
      '/forecast-rents-utility-allowance-form',
      JSON.stringify(data),
    );
  }
  async getForecastRentsUtilityAllowanceForm(rentForecastId) {
    return await get(
      `/forecast-rents-utility-allowance-form/${rentForecastId}`,
    );
  }
}
